import CachedImage from "./CachedImage";

export default CachedImage;
